export const HOME_PAGE = '/';
export const LOGIN_PAGE = '/login';
export const PRICING_PAGE = '/pricing';
export const CONTACT_PAGE = '/contact';
export const REGISTER_PAGE = '/register';
export const MY_COMPANY_PAGE = '/my-company';
export const MY_PACKAGE_PAGE = '/my-package';
export const RESETPASS_PAGE = '/reset-password';

